import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";
import Error from "next/error";

interface GoodsByMenu {
	goodsCd: string;
	goodsTourInfo: string;
	outStartDateList: string;
	wdayList: string;
	outDeprtFgList: string;
	airName: string;
	airCd: string;
	evDayCntList: string;
	dspSid: string;
	dspSidHi: string;
	goodsGbn: string;
	outCityDiviNm: string;
	minPrice: number;
	maxPrice: number;
	goodsNm: string;
	minStartDt: string;
	maxStartDt: string;
	imageThum3: string;
	goodsTp: string;
	goodsTpNm: string;
	rervCnt: number;
	webGuidConfYn: string;
	goodsBrandCd: string;
	goodsBrandNm: string;
	goodTravelYn: string;
	evProgDiviList: string;
	couponYn: string;
	couponOptTy: string;
	startFixOpenDtList: string;
	outStartWdayMonList: string;
	outStartWdayPcnt: number;
	trCompanyList: string;
	goodsFeaturesDiviList: string;
	goodsFeaturesList: string;
	goodsTpointContents: string;
	goodsTmember: string;
	keyWordList: string;
	goodsPromotion: string;
	mainImgCnt: number;
	rvwAvgScore: number;
	rvwCnt: number;
	couponDiscRate: number;
	couponDiscAmt: number;
	webDisplayCls: string;
	ypdPrice: number;
	ypdYn: string;
	sortOrderInfo: string;
	sortOrder: number;
	bestYn: string /*  컬럼명 BEST_YN (braze)*/;
	themaDivi: string /* 컬럼명 THEMA_DIVI (braze)*/;
	goodsPromotionCd: string /* 컬럼명 GOODS_PROMOTION_CD (braze)*/;
	goodsEmphasisDivi: string /* (braze) */;
	continentCd: string; // Braze
	continentNm: string; // Braze
	countryCd: string; // Braze
	countryNm: string; // Braze
	rervTourlistCnt: number /** 최근 30일 기준 실예약 인원 수 */;
}

/** ```
 * 상품 리스트 조회
 *   `/api/goods/by-menu/${dspSid}`
 * parameter
 *   `dspSid` 지역코드
 * ```*/
const key = "useGoodsByMenu";
const getPath = (dspSid: string): string =>
	`${publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH}/api/goods/by-menu/${dspSid}`;

/** ```
 * 상품 리스트 조회
 *   `/api/goods/by-menu/${dspSid}`
 * parameter
 *   `dspSid` 지역코드
 * ```*/
const useGoodsByMenu = (dspSid: string, options?: Partial<UseQueryOptions<Response<GoodsByMenu[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(dspSid)],
		queryFn: () => useConfigureAxios({url: getPath(dspSid)}).then(r => r.data),
		staleTime: Infinity,
		gcTime: Infinity,
		...options,
	});

export default useGoodsByMenu;
export {getPath};
export type {GoodsByMenu};
